import * as d3 from 'd3'
import * as R from 'ramda'

/**
 * React ref to d3 selection
 */
export default R.pipe(R.prop('current'), d3.select)
